export enum CardFooterVariant {
    default = 'default',
    sticky = 'sticky',
}

export enum CardFooterContentPosition {
    left = 'left',
    right = 'right',
}
